'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$24() {
  this.bf8 = null;
  this.bf6 = null;
  this.bf7 = false;
  this.bf4 = null;
  this.bf5 = false;
  this.bf9 = false;
  this.bfa = false;
  this.bf8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$24 as $c_Lpresto_PrestoRouter$$anon$24 };
$p = $c_Lpresto_PrestoRouter$$anon$24.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$24;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$24() {
}
export { $h_Lpresto_PrestoRouter$$anon$24 as $h_Lpresto_PrestoRouter$$anon$24 };
$h_Lpresto_PrestoRouter$$anon$24.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bf8;
});
$p.t = (function() {
  if ((!this.bf7)) {
    this.bf6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bf7 = true;
  }
  return this.bf6;
});
$p.ad = (function() {
  if ((!this.bf5)) {
    this.bf4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bf5 = true;
  }
  return this.bf4;
});
$p.v = (function() {
  if ((!this.bfa)) {
    this.bf9 = false;
    this.bfa = true;
  }
  return this.bf9;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$24 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$24, "presto.PrestoRouter$$anon$24", ({
  NY: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$24 as $d_Lpresto_PrestoRouter$$anon$24 };
//# sourceMappingURL=presto.-Presto-Router$$anon$24.js.map
